<template>
  <div id="modalNoticeView" class="modal fade">
    <div
      class="modal-dialog modal-dialog-vertical-center modal-lg"
      role="document"
    >
      <div class="modal-content bd-0 tx-14">
        <modal-loading :show="loading"></modal-loading>
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{ elem.title }}
          </h6>
          <button
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            class="close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div
          class="modal-body pd-25"
          style="color: #343a40"
          v-html="elem.content"
        ></div>
        <div class="modal-footer">
          <button
            type="button"
            class="
              btn btn-secondary
              tx-11 tx-uppercase
              pd-y-12 pd-x-25
              tx-mont tx-semibold
            "
            data-dismiss="modal"
          >
            {{ $t("express.关闭") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {
      loading: false,
      elem: this.item,
    };
  },
  watch: {
    "item.isShow"() {
      this.initDate();
    },
  },
  created() {
    this.initDate();
  },
  methods: {
    initDate() {
      if (this.item.id) {
        this.getNotice();
      }
    },
    getNotice() {
      this.loading = true;
      $.api_call(
        "api.Notice.getNoticeDetail",
        {
          id: this.item.id,
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            this.elem = r.Data.Results;
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
  },
};
</script>

<style lang="less">
.modal-body {
  img {
    width: 100%;
  }
}
</style>
